import React, { useEffect } from 'react';
import { useSearchActionResolver } from '../hooks';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { DomainSearchSuiteModule } from '../../../domainSearchSuite.module';
import { DomainSearchError } from '../../types';
export const Status = () => {
  const _useSearchActionResol = useSearchActionResolver(),
    actionStatus = _useSearchActionResol.actionStatus,
    domainName = _useSearchActionResol.domainName,
    externalViewer = _useSearchActionResol.externalViewer,
    status = _useSearchActionResol.status;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useDomainsAccount({}),
    accountParams = _DomainsApiClient$hoo.data;
  const _ref = accountParams ?? {},
    msid = _ref.msid,
    siteName = _ref.siteName;
  const _DomainsApiClient$hoo2 = DomainsApiClient.hooks.useIsPremiumDomain({
      domain: domainName
    }, !!domainName),
    isPremiumResult = _DomainsApiClient$hoo2.data;
  useEffect(() => {
    if (status && status !== DomainSearchError.NO_STATUS) {
      DomainSearchSuiteModule.internals.bi.onSearchResultLoad == null || DomainSearchSuiteModule.internals.bi.onSearchResultLoad({
        result: status,
        domain: domainName,
        type: 'search-result',
        isPremiumDomain: isPremiumResult == null ? void 0 : isPremiumResult.isPremiumDomain
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
  if (!actionStatus) {
    return null;
  }
  return 'StatusComponent' in actionStatus && actionStatus.StatusComponent ? /*#__PURE__*/React.createElement(actionStatus.StatusComponent, {
    action: actionStatus.action,
    msid: msid,
    siteName: siteName,
    domainName: domainName,
    datahook: status,
    externalViewer: externalViewer,
    status: status
  }) : null;
};
//# sourceMappingURL=Status.js.map